import { validateCep } from 'validations-br';

class CEPValidatorAdapter {
  isValid (cep) {
    return validateCep(cep);
  }
}

export default CEPValidatorAdapter;
